import { Characters } from '../../helpers/unicode.helper';
import { useField } from 'formik';

import { HumanReadableEnumValue } from '../../enums/HumanReadableEnumValue';

export const FormikHumanReadableEnumValue = (props) => {
    const [field] = useField(props.name);

    if (!field.value) {
        return props.fallback ?? Characters.EN_DASH;
    }

    return <HumanReadableEnumValue enumType={props.enumType} value={field.value} />;
};
